export default __webpack_public_path__ + "static/media/img_blanketBunny_grey.b25a44e8.jpg";